export default __webpack_public_path__ + "static/media/hand-pen-01.b5aa1de4.svg";